import React from 'react'
import PropTypes from 'prop-types'

import { Box, Typography, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExternalLink } from '@fortawesome/pro-solid-svg-icons'

import useCollegeName from 'common/use-college-name'
import AudienceInsights from './AudienceInsights'

const useStyle = makeStyles((theme) => ({
  slateScreenShotPlaceholder: {
    width: 480,
    height: 120,
    backgroundColor: 'lightgrey',
    borderRadius: 8,
  },
  congrats: {
    fontSize: theme.typography.pxToRem(20),
  },
  bold: {
    fontWeight: 600,
  },
}))

const ConfigurationComplete = () => {
  const styles = useStyle()
  const collegeName = useCollegeName()

  return (
    <>
      <Box
        mt={1}
        mb={3}
      >
        <Typography
          className={styles.congrats}
          variant="body2"
        >
          Congrats, <strong>{collegeName}!</strong>
        </Typography>
      </Box>
      <Typography
        variant="h3"
        className={styles.bold}
      >
        You connected Slate and Scoir
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
      >
        Now, you can message your Scoir audience directly from Slate, and more accurately attribute first source data from stealth 
        students. If you have any questions, we're here to help.
        <br /><br />
        Your Success Manager will reach out soon with your stealth student data breakdown.
        <br /><br />
        <strong>Strapped for time?</strong> We can help you engage 
        and convert your stealth audience, and get the most value possible out of your Slate and Scoir integration. Let us manage 
        your stealth strategy for you with <a href="https://www.scoir.com/colleges/managed-subscriptions">Managed Subscriptions</a>.
      </Typography>
      <Box my={3}>
        <AudienceInsights />
      </Box>
      <Button
        variant="contained"
        size="large"
        color="primary"
        href="https://www.scoir.com/colleges/integration-slate#get-in-touch"
        component="a"
        rel="noopener noreferrer"
        target="_blank"
      >
        Get in Touch&nbsp;&nbsp;
        <FontAwesomeIcon icon={faExternalLink} />
      </Button>
    </>
  )
}

ConfigurationComplete.propTypes = {
  config: PropTypes.object,
}

export default ConfigurationComplete
